<template>
  <div class="miniProgram fixed_horizo_center">
    <van-form ref="form">
      <van-cell required title="小程序标题">
        <template #default>
          <van-field
            v-model="addForm.title"
            name="miniTitle"
            type="text"
            maxlength="12"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入小程序标题' }]"
          />
        </template>
      </van-cell>
      <van-cell required title="小程序appid">
        <template #default>
          <van-field
            v-model="addForm.appId"
            name="appid"
            type="text"
            maxlength="128"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入小程序appid' }]"
          />
        </template>
      </van-cell>
      <van-cell required title="小程序路径">
        <template #default>
          <van-field
            v-model="addForm.linkUrl"
            name="miniAdd"
            type="text"
            maxlength="500"
            show-word-limit
            placeholder="请输入..."
            :rules="[{ required: true, message: '请输入小程序路径' }]"
          />
        </template>
      </van-cell>
      <van-cell title="封面" required>
        <template #default>
          <van-field name="fillcover" :rules="[{ required: true, message: '请上传小程序封面' }]" v-model="addForm.url">
            <template #input>
              <div class="form-upload">
                <img-file :size="Imgsize" @uploadImg="welcomeImg"></img-file>
                <div v-if="!addForm.url" class="updataimgs">
                  <van-icon name="plus" />
                  <span class="center-text">上传封面图</span>
                </div>
                <img v-if="addForm.url" class="upload-back-img" :src="addForm.url" alt="" />
              </div>
              <div class="imgtext">仅支持jpg，png文件，且不超过10M，建议尺寸：160x160px</div>
            </template>
          </van-field>
        </template>
      </van-cell>
    </van-form>
    <div class="fixed_bottom fixed_horizo_center">
      <div class="button_bottom">
        <dl @click="resetUser">取消</dl>
        <dl @click="ensureComfirm" ref="ensureConfirm" :style="{ opacity: addForm.title && addForm.appId && addForm.linkUrl && addForm.url ? 1 : 0.5 }">确认</dl>
      </div>
    </div>
  </div>
</template>

<script>
// import { wxConfig } from "../fastReply/js/config";
import ImgFile from "@/views/wegroupsend/imgFile";
export default {
  name: "miniProgram",
  components: { ImgFile },
  props: ["showMini", "isEdit", "current", "ruleForm"],
  data() {
    return {
      addForm: {
        linkUrl: "",
        content: "",
        orderNum: "",
        picUrl: "",
        title: "",
        appId: "",
        url: "",
        msgType: "miniprogram",
        fileName: "",
      },
      Imgsize: 10,
    };
  },
  created() {
    // this.relaxWxConfig();
  },

  watch: {
    showMini(val) {
      if (val) {
        if (this.isEdit) {
          this.addForm = { ...this.ruleForm };
        }
      }
    },
  },

  methods: {
    ensureComfirm() {
      let form = this.$refs.form;
      form
        .validate(["miniTitle", "appid", "miniAdd", "fillcover"])
        .then(() => {
          if (this.isEdit) {
            this.addForm.fileName = this.addForm.title;
            this.$emit("editFileUpload", this.addForm, this.index);
            Object.assign(this.$data, this.$options.data());
          } else {
            this.addForm.fileName = this.addForm.title;
            this.$emit("uploadInfo", this.addForm);
            Object.assign(this.$data, this.$options.data());
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    resetUser() {
      this.$emit("cancelBack");
    },

    welcomeImg(obj) {
      console.log(obj);
      this.addForm.url = obj.url;
    },
  },
};
</script>

<style scoped lang="less">
.miniProgram {
  width: 100%;
  padding: 20px 30px;
  position: fixed;
  min-height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: #f6f6f6;
  .van-form {
    .van-cell {
      flex-direction: column;
      margin-bottom: 10px;
      border-radius: 10px;
      /deep/.van-cell__title {
        text-align: left;
        font-size: 28px;
        margin-left: 10px;
        color: #666666;
      }
      /deep/.van-field__word-limit {
        margin-top: -4px;
      }
      /deep/.van-field__control--custom {
        flex-direction: column;
        align-items: start;
        .form-upload {
          width: 160px;
          height: 160px;
          position: relative;
          .updataimgs {
            position: absolute;
            top: 0;
            background-color: #fafafa;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
            width: 160px;
            height: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            i {
              font-size: 34px;
              margin-top: -26px;
              color: #999999 !important;
            }
            .center-text {
              font-size: 20px;
              color: #999999;
              position: absolute;
              bottom: 14px;
            }
          }
          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .imgtext {
          font-size: 20px;
          text-align: left;
          color: #999999;
        }
        &:after {
          border: none;
        }
      }
    }
    /deep/.van-cell--required::before {
      top: 10px;
    }
    .van-field {
      padding: 10px 0;
      /deep/.van-field__word-limit {
        color: #999999;
      }
    }
  }
  .fixed_bottom {
    .button_bottom {
      dl:nth-child(2) {
        opacity: 1;
      }
    }
  }
}
</style>
